import { createContext, useMemo } from 'react';

import type { Publication } from '~/interfaces/publication';
import type { OrganizationSubscription, SubscriberPreference } from '~/interfaces/subscriber_preferences';
import type { Subscription } from '~/interfaces/subscriptions';

import type { PreferencesLoaderData } from '../preferences';

export type ContextType = {
  publication: Publication;
  subscription: Subscription | null;
  subscriberId: string;
  isLoggedIn: boolean;
  preferences: SubscriberPreference[] | null;
  organizationSubscriptions: OrganizationSubscription[] | null;
};

const PreferencesContext = createContext<ContextType | undefined>(undefined);
PreferencesContext.displayName = 'PreferencesContext';

const PreferencesProvider = ({
  loaderData,
  children,
}: {
  loaderData: PreferencesLoaderData;
  children: React.ReactNode;
}) => {
  const { subscription, subscriberId, isLoggedIn, publication, preferences, organizationSubscriptions } = loaderData;

  const context: ContextType = useMemo(
    () => ({
      publication,
      subscription: subscription || null,
      subscriberId,
      isLoggedIn,
      preferences,
      organizationSubscriptions,
    }),
    [publication, subscription, subscriberId, isLoggedIn, preferences, organizationSubscriptions],
  );

  return <PreferencesContext.Provider value={context}>{children}</PreferencesContext.Provider>;
};

export { PreferencesContext, PreferencesProvider };
